import { Routes } from '@angular/router';
import { LoginComponent, UnauthorizedComponent } from './shared/components';
import { HomeComponent } from './pages/home/home.component';
import { MainComponent } from './pages/main/main.component';
import { ListadoEmpresas } from './pages/configuracion/listado-empresas/listado-empresas.component';
import { ConfiguracionAsistencia } from './pages/configuracion/configuracion-asistencia/configuracion-asistencia.component';
import { ListadoAcEjecucionComponent } from './pages/seguimiento/listado-ac-ejecucion/listado-ac-ejecucion.component';
import { SeguimientoAsistenciaComponent } from './pages/seguimiento/seguimiento-asistencia/seguimiento-asistencia.component';
import { ListadoAcComponent } from './pages/reportes/listado-ac/listado-ac.component';
import { DetalleReporteAsistenciaComponent } from './pages/reportes/detalle-reporte-asistencia/detalle-reporte-asistencia.component';

export const routes: Routes = [
    { path: '', redirectTo: 'login', pathMatch: 'full' },
    { path: 'login', component: LoginComponent },
    {
        path: '',
        component: MainComponent,
        // canActivate: [MainGuard],
        // canActivateChild: [MainGuard],
        children: [
            { path: '', component: HomeComponent },
            { path: 'home', component: HomeComponent },
            { path: 'listado-empresas', component: ListadoEmpresas },
            { path: 'listado-empresas/configuracion-asistencia/:id', component: ConfiguracionAsistencia},
            { path: 'listado-ac-ejecucion', component: ListadoAcEjecucionComponent },
            { path: 'listado-ac-ejecucion/seguimiento-asistencia/:id', component: SeguimientoAsistenciaComponent },
            { path: 'listado-ac', component: ListadoAcComponent },
            { path: 'listado-acdetalle-reporte-asistencia/:id', component: DetalleReporteAsistenciaComponent },
        ]
    },
    { path: 'unauthorized', component: UnauthorizedComponent },
    { path: '**', redirectTo: 'unauthorized' }
];
